<template>
<header>
  <!-- <a :href="$store.state.host.plus" style="position:absolute; color:black; top:12px; left:15px; font-size:12px;">
    <b>HOME</b>
  </a> -->
   <!-- <a @click="goApp($store.state.preUrl);" class="btnPre1" v-if="backCheck">이전으로</a>
  <strong class="logo">
    <a @click="goApp();"><img :src="`${$store.state.dir}images/logo_bmw.png`" alt="BMW"></a>
  </strong> -->

  <strong class="logoTitle">
    <sapn>{{ pageTitle }}</sapn>
    <button type="button" class="btnClose" @click="goApp();">이전으로</button>
  </strong>

  <form ref="estimateForm" name="estimateForm" method="post" v-show="false">
    <input type="hidden" name="selOpt"        :value="selOpt"/>
    <input type="hidden" name="campaignNo"    :value="campaignNo"/>
    <input type="hidden" name="brdCampaignNo" :value="brdCampaignNo"/>
    <input type="hidden" name="vehicleIdx"    :value="vehicleIdx"/>
    <input type="hidden" name="scpNo"         :value="scpNo"/>
    <input type="hidden" name="brdScpNo"      :value="brdScpNo"/>
  </form>

</header>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {

    ...mapState({
      hostVtg: state => state.host.vtg,
      selOpt: state => state.selOpt,
      campaignNo: state => state.campaignNo,
      brdCampaignNo: state => state.brdCampaignNo,
      vehicleIdx: state => state.vehicleIdx,
      scpNo: state => state.scpNo,
      brdScpNo: state => state.brdScpNo,
    }),

    backCheck() {
      return [
        'SubscGuide',  //메인화면
        'Subsc',       //구독정보
        'SubscVtg',      //구독정보
        'SubscRevoke', //해지신청
        'GuideSubscApply', //가입방법
        'GuideInsurance', //보험 청구 방법
      ].includes(this.$route.name);
    },
  },
  data() {
    return {
      pageTitle: "BMW ServiceCare+ 구독 신청"
    }
  },

  created() {
    // 페이지가 생성될 때마다 URL의 변경을 감지하여 페이지 타이틀을 업데이트합니다.
    this.updatePageTitle();

    this.$watch('$route', ( to ) => {
      // 경로가 변경될 때마다 실행되는 로직
      if (to.path === "/guide/total") {
        this.pageTitle = "구독 신청 방법 및 이용 방법";
      } else if (to.path === "/subscApply/term") {
        this.pageTitle = "BMW ServiceCare+ 구독 신청";
      } else {
        this.pageTitle = "BMW 서비스 케어 플러스";
      }
    });
  },

  methods: {
    goApp(preUrl = false)
    {
      this.$store.commit('setBtnLoading', true);

      // 이전 url 존재시 해당 페이지로 이동
      if(preUrl && this.selOpt != null) 
      {
        let estimateForm = this.$refs.estimateForm;
        estimateForm.action = this.hostVtg + preUrl;
        return estimateForm.submit();
      }
      //이전 url 미존재시 메인 이동
      else 
      {
        return location.href = this.hostVtg + ( (preUrl) ? preUrl : '' );
      }
     
    },
    updatePageTitle() {

      // URL에 따라 페이지 타이틀을 변경합니다.
      let pathName = this.$route.path;
      console.log( "pathName:" + pathName );

      if (pathName === "/guide/total") {
        this.pageTitle = "구독 신청 방법 및 이용 방법";
      } else if (pathName === "/subscApply/term") {
        this.pageTitle = "BMW ServiceCare+ 구독 신청";
      } else {
        this.pageTitle = "BMW 서비스 케어 플러스";
      }
    },
  },
}
</script>


<style scoped>

</style>